










































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { required } from 'vuelidate/lib/validators';
import ACHAccountForm from '../../components/ACHAccountForm.vue';
import CreditCardForm from '../../components/CreditCardForm.vue';
import { AddPaymentSourceRequest } from '@/types/request';
import { CommonUtils } from '@/util/commonUtils';

@Component({
     components: {
      ACHAccountForm,
      CreditCardForm,
   },
   props: {
        customerId: String,
        billingLocations: {
            type: Array,
            required: false,
        },
   },
})

export default class AddPaymentModal extends Vue {
    private show = true;
    private paymentSources: [] = [];
    private showCreditCardForm = false;
    private showACHAccountForm = false;
    private paymentSource: string = '';
    private selectedLocationIds: string[] = [];
    private isLocationSelected = false;

    public mounted() {
        this.getPayment('card');
    }
    private saveACHCard(paymentSource: any, selectedLocations?: string[]) {
        if (paymentSource) {
            this.paymentSource = paymentSource;
            this.selectedLocationIds = selectedLocations || [];
            if (this.selectedLocationIds.length && this.$props.billingLocations.length) {
                this.isLocationSelected = true;
            } else if (!this.$props.billingLocations) {
                this.isLocationSelected = true;
            }
        } else {
            this.paymentSource = '';
        }
    }
    private saveCreditCard(paymentSource: any) {
        if (paymentSource && paymentSource.cardToken
                && paymentSource.cardToken.token) {
            this.paymentSource = paymentSource.cardToken.token.id;
            this.selectedLocationIds = paymentSource.selectedLocations || [];
            if (this.selectedLocationIds.length && this.$props.billingLocations.length) {
                this.isLocationSelected = true;
            } else if (!this.$props.billingLocations) {
                this.isLocationSelected = true;
            }
        } else {
            this.paymentSource = '';
        }
    }
    private getPayment(paymentType: any) {
        if (paymentType === 'bank_account') {
            this.showCreditCardForm = false;
            this.showACHAccountForm = true;
            }
        if ( paymentType === 'card') {
            this.showACHAccountForm = false;
            this.showCreditCardForm = true;
        }
    }
    private addPayment() {
        if (this.showCreditCardForm) {
            this.addCustomerCreditCard();
        }
        if (this.showACHAccountForm) {
            this.addACHCard();
        }
    }

    private async addACHCard() {
        const addPaymentSourceRequest: AddPaymentSourceRequest = {
            customerId: this.$props.customerId,
            paymentSource: this.paymentSource,
            billingLocationIds: this.selectedLocationIds,
        };
        const response = await ObjectFactory.getPaymentSourceService().
        addACHCard(addPaymentSourceRequest, this.$store.state.serverUrl);
        if (response.success) {
            this.$emit('close');
            this.$emit('success');
        } else {
            CommonUtils.showError(response);
        }
    }
    private async addCustomerCreditCard() {
        const addPaymentSourceRequest: AddPaymentSourceRequest = {
            customerId: this.$props.customerId,
            paymentSource: this.paymentSource,
            billingLocationIds: this.selectedLocationIds,
        };
        const response = await ObjectFactory.getPaymentSourceService().
        addCustomerCreditCard(addPaymentSourceRequest, this.$store.state.serverUrl);
        if (response.success) {
            this.$emit('close');
            this.$emit('success');
        } else {
            CommonUtils.showError(response);
        }
    }
    private close() {
        this.$emit('close');
    }
}
